export const faqsPl = [
  {
    q: "Jakie mikrokontrolery i platformy obsługujecie?",
    a: "Najczęściej piszemy firmware na STM32, ESP32 i Nordic nRF (nRF52/nRF53/nRF54) oraz na Zephyr RTOS / nRF Connect SDK. Dobieramy platformę do baterii, łączności i wymagań produkcyjnych — nie do portfolio technologii.",
  },
  {
    q: "Czy robicie firmware LTE-M i NB-IoT?",
    a: "Tak. Integrujemy moduły LPWA, zarządzamy połączeniem, oszczędzaniem energii i wysyłką danych do chmury. LTE-M i NB-IoT pojawiają się w leadach jako PoC łączności do istniejących produktów IoT.",
  },
  {
    q: "Czy wdrażacie aktualizacje OTA / DFU?",
    a: "Tak — bezpieczne OTA/DFU to standard w produktach, które mają żyć dłużej niż jedna wersja firmware. Projektujemy pipeline aktualizacji razem z aplikacją lub backendem.",
  },
  {
    q: "Czy piszecie tylko firmware, czy też aplikację towarzyszącą?",
    a: "Możemy zrobić sam firmware albo pełny stack: urządzenie + aplikacja mobilna + backend. W leadach klienci często proszą o obie warstwy w jednym zapytaniu.",
  },
  {
    q: "Ile trwa napisanie firmware do PoC?",
    a: "Prosty PoC na DevKit (odczyt sensorów, komunikacja, podstawowa logika) to zwykle 2–6 tygodni. Firmware produkcyjny z OTA, testami i optymalizacją energii — od kilku miesięcy wzwyż.",
  },
  {
    q: "Czy przejmujecie istniejący kod firmware od innego dostawcy?",
    a: "Tak. Zaczynamy od audytu, mapujemy ryzyka i proponujemy plan refaktoryzacji albo dokończenia funkcji — bez przepisywania wszystkiego od zera, jeśli nie ma takiej potrzeby.",
  },
  {
    q: "Czy Zephyr RTOS ma sens w naszym produkcie?",
    a: "Często tak przy Nordic nRF i produktach z wieloma peryferiami, OTA i długim cyklem życia. Przy prostych urządzeniach bare-metal lub lżejszy stack bywa wystarczający — dobieramy świadomie.",
  },
  {
    q: "Od czego zależy koszt firmware embedded?",
    a: "Od liczby interfejsów, wymagań bateryjnych, łączności, OTA, testów sprzętowych i dokumentacji. Po konsultacji szacujemy zakres PoC vs ścieżkę do produkcji.",
  },
] as const;
